import { Puzzle, Plus } from "lucide-react";

export default function AddonIcon({ size = 20 }) {
  return (
    <div className="relative inline-flex items-center justify-center">
      {/* Puzzle base icon */}
      <Puzzle size={size} className="text-primary" />

      {/* Small plus badge */}
      <Plus
        size={size / 1.5}
        className="absolute bottom-0 right-0 bg-white text-green-600 rounded-full shadow-sm"
      />
    </div>
  );
}
